var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('commonaside')],1),_c('el-container',[_c('el-header',[_c('commonheader')],1),_c('Commontag'),_c('el-main',{staticStyle:{"padding":"0px","margin-left":"10px","margin-right":"10px","padding-top":"10px"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }